<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import echarts from "echarts";
import resize from "@/mixins/resize";

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    options: {
      type: Object,
      // required: true
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    options: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.options);
    },

    seriesData() {
      const color = ["#3673E8", "#61B8FF", "#F5B763"];
      const colorOpa = ["34, 118, 252", "95, 213, 236", "255, 207, 95"];
      var series = [];
      let seriesData = this.options.seriesData
      for (let key in seriesData) {
        var data = seriesData[key].detailDataList.map(
          (i) => i.collectionNumber
        );
        var item = {
          name: seriesData[key].certificateName,
          smooth: true,
          type: "line",
          itemStyle: {
            normal: {
              color: color[key],
              lineStyle: {
                color: color[key],
                width: 2,
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: `rgba(${colorOpa[key]}, 0.2)` },
                  { offset: 1, color: `rgba(${colorOpa[key]}, 0)` },
                ]),
              },
            },
          },
          data: data,
          animationDuration: 2800,
          animationEasing: "quadraticOut",
          symbol: "none",
        };
        series.push(item);
      }
      return series;
    },
    
    setOptions({ xAxis, legList } = {}) {
      this.chart.setOption({
        xAxis: {
          data: xAxis,
          boundaryGap: true,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              width: 2,
              color: "rgba(255, 255, 255, 0.6)",
            },
          },
          axisLabel: {
            show: true,
            textStyle: {
              color: "rgba(255, 255, 255, 0.6)",
            },
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: 0,
          right: 0,
          bottom: 0,
          top: 50,
          containLabel: true,
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            textStyle: {
              fontSize: 12,
              color: "rgba(255, 255, 255, 0.6)",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted",
              color: "rgba(255, 255, 255, 0.15)",
            },
          },
        },
        legend: {
          data: legList,
          top: "0",
          right: "20",
          textStyle:{
            color:"rgba(255, 255, 255, 0.8)",
          }
          
        },
        series: this.seriesData(),
      },true);
    },
  },
};
</script>
